import * as PlayerActionTypes from './action-types.constants';
export const createPlayer = (media,containerEl) => {
    return {
        type: PlayerActionTypes.CREATE_PLAYER,
        media,
        containerEl
    }
}
export const setMedia = (media) => {
    return {
        type: PlayerActionTypes.SET_MEDIA,
        media
    }
}
export const changePlayer = (player, medium, mediaId) => ({
    type: PlayerActionTypes.CHANGE_PLAYER,
    player,
    medium,
    mediaId
})
export const destroyPlayer = () => {
    return {
        type: PlayerActionTypes.DESTROY_PLAYER
    }
}
export const playerCreated = (player, mediaId) => {
	//console.log("[PlayerAction] playerCreated",arguments);
    const data = {
        type: PlayerActionTypes.PLAYER_CREATED,
        player,
        mediaId
    }
    return data;
}

export const playerEventMediaChange = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_MEDIACHANGE,
    data
})

export const playerEventEnded = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_ENDED,
    data
})

export const playerEventMuteChange = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_MUTECHANGE,
    data
})


export const playerEventLoadedData = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_LOADEDDATA,
    data
})

export const playerEventPlaying = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_PLAYING,
    data
})
export const playerEventPaused = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_PAUSED,
    data
})
export const playerEventTimeupdate = (data) => ({
    type: PlayerActionTypes.PLAYER_EVENT_TIMEUPDATE,
    data
})


